<template>
    <div class="news" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div class="newsBox" :style="'background-color: ' + item.bgColor.color[0].item + ';'" :class="{'border-radius': item.bgStyle.type == 1}">
            <div class="logo">
                <img :src="item.logoConfig.url">
            </div>
            <div class="newsText">
                <span v-if="item.listConfig.list.length > 0 && item.listConfig.list[0].child[0].val">{{item.listConfig.list[0].child[0].val}}</span>
                <span v-else>暂无内容～</span>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    methods: {}
};
</script>

<style scoped lang="scss">
.newsBox {
    display: flex;
    align-items: center;
    height: 30px;
    font-size: 14px;
    .logo{
        width: 75px;
        height: 18px;
        padding-right: 10px;
        border-right: 1px solid #ddd;
        margin-left: 7px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .newsText{
        flex: 1;
        position: relative;
        padding: 0 20px 0 10px;
        margin-right: 7px;
        white-space: nowrap; /* 防止换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 使用省略号表示被省略的文本 */
        i{
            position: absolute;
            right: 0;
            line-height: 21px;
        }
    }
}

.border-radius{
    border-radius: 6px;
}
</style>